import styled from 'styled-components';
import ChaMeta13 from 'dc/ChaMeta13';

export const Wrapper = styled.div`
  background-color: transparent;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  max-height: 310px;
  overflow-y: auto;
`;

export const SectionItem = styled(ChaMeta13)`
  min-height: 78px;
`;
